import { ArrowUpRight03Icon, PaintBoardIcon } from '@hugeicons/core-free-icons';
import { useNavigate } from 'react-router-dom';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';

import { BrandingEdit } from './BrandingEdit/BrandingEdit';

export const BrandDetails = ({ brand, show = false, onClose = () => {} }) => {
  const navigate = useNavigate();
  return (
    show &&
    brand && (
      <AnimatedModal
        visible={show}
        onClose={onClose}
        icon={PaintBoardIcon}
        oldIconLibrary={false}
        title={brand?.name}
        className="readonly-modal"
        fullscreen={false}
        customActions={[
          {
            icon: ArrowUpRight03Icon,
            text: 'Go to Brand',
            onClick: () => {
              navigate(`/company/branding?brandId=${brand.id}`);
              onClose();
            },
          },
        ]}
        status={{
          text: 'Read Only',
          status: 'neutral',
        }}>
        <BrandingEdit brand={brand} readOnly={true} />
      </AnimatedModal>
    )
  );
};
